import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import HitCardDetails from '../Common/HitCardDetails';
import HitCardHeader from '../Common/HitCardHeader';
import HitCardActions from '../Common/HitCardActions';
import { showEntityChangelogs } from '../../../reducers/entityChangelogs';

const visibleAttributes = [
  'email',
  'phone_number',
  'street_address',
  'street_address_line_2',
  'city',
  'state',
  'country',
  'zip_code',
  'full_address',
  'number_of_users'
];

const HitCard = ({ hit }) => {
  const [expanded, setExpanded] = React.useState(false);
  const dispatch = useDispatch();

  const actions = [
    {
      disabled: !hit.has_changelog,
      label: 'Changelog',
      onclick: () => dispatch(showEntityChangelogs(hit.model_id, hit.full_name, 'location'))
    }
  ];
  return (
    <>
      <HitCardHeader hit={hit} expanded={expanded} setExpanded={setExpanded} />
      <HitCardActions hit={hit} actions={actions} />
      <HitCardDetails hit={hit} visibleAttributes={visibleAttributes} expanded={expanded} />
    </>
  );
};

HitCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  hit: PropTypes.object.isRequired
};

HitCard.defaultProps = {};

export default HitCard;
